/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetTypeCreation } from '../models/AssetTypeCreation';
import type { AssetTypeListing } from '../models/AssetTypeListing';
import type { AssetTypeRetrieval } from '../models/AssetTypeRetrieval';
import type { AssetTypeUpdate } from '../models/AssetTypeUpdate';
import { request as __request } from '../core/request';

export class AssetTypesService {

    /**
     * List asset types
     * @returns any
     * @throws ApiError
     */
    public static async listAssetTypes({
        slug,
        page,
        pageSize,
    }: {
        slug?: string,
        /** A page number within the paginated result set. **/
        page?: number,
        /** Number of results to return per page. **/
        pageSize?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<AssetTypeListing>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/asset-types/`,
            query: {
                'slug': slug,
                'page': page,
                'page_size': pageSize,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * Create a new asset type object
     * @returns AssetTypeCreation
     * @throws ApiError
     */
    public static async createAssetType({
        data,
    }: {
        data: AssetTypeCreation,
    }): Promise<AssetTypeCreation> {
        const result = await __request({
            method: 'POST',
            path: `/asset-types/`,
            body: data,
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * Get the details of a single asset type
     * @returns AssetTypeRetrieval
     * @throws ApiError
     */
    public static async getAssetType({
        uuid,
    }: {
        /** A UUID string identifying this asset type. **/
        uuid: string,
    }): Promise<AssetTypeRetrieval> {
        const result = await __request({
            method: 'GET',
            path: `/asset-types/${uuid}/`,
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * Replace the specified asset type
     * @returns AssetTypeUpdate
     * @throws ApiError
     */
    public static async updateAssetType({
        uuid,
        data,
    }: {
        /** A UUID string identifying this asset type. **/
        uuid: string,
        data: AssetTypeUpdate,
    }): Promise<AssetTypeUpdate> {
        const result = await __request({
            method: 'PUT',
            path: `/asset-types/${uuid}/`,
            body: data,
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * Partially update the specified asset type
     * @returns AssetTypeUpdate
     * @throws ApiError
     */
    public static async partialUpdateAssetType({
        uuid,
        data,
    }: {
        /** A UUID string identifying this asset type. **/
        uuid: string,
        data: AssetTypeUpdate,
    }): Promise<AssetTypeUpdate> {
        const result = await __request({
            method: 'PATCH',
            path: `/asset-types/${uuid}/`,
            body: data,
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * Delete the specified asset type
     * @returns void
     * @throws ApiError
     */
    public static async destroyAssetType({
        uuid,
    }: {
        /** A UUID string identifying this asset type. **/
        uuid: string,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/asset-types/${uuid}/`,
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

}